"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationTypography = exports.UserPronounsSpan = exports.UserPronounsTypography = exports.LineOfTextContainer = exports.UserNameLink = exports.AvatarInfo = exports.AvatarLockupContainer = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var colors_1 = require("../ThemeProvider/colors");
var Typography_1 = __importDefault(require("../Typography"));
var Link_1 = __importDefault(require("../Link"));
var outlineColor = ' #0060E0';
exports.AvatarLockupContainer = (0, styled_1.default)('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});
exports.AvatarInfo = (0, styled_1.default)('div')(function (props) { return ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: props.align === 'left' ? 'flex-start' : 'flex-end',
    padding: '8px',
    '> div': {
        display: 'inline-flex',
        columnGap: '4px',
    },
}); });
exports.UserNameLink = (0, styled_1.default)(Link_1.default)(function (props) { return (__assign(__assign({ fontWeight: props.emphasized ? '800' : '500' }, (props.lineOfText && { fontSize: 'inherit' })), { ':focus-visible': {
        outline: "2px solid ".concat(outlineColor),
        outlineOffset: '2px',
        borderRadius: '2px',
    } })); });
exports.LineOfTextContainer = (0, styled_1.default)('div')({
    display: 'inline-flex',
    columnGap: '4px',
    alignItems: 'baseline',
});
var PronounStyles = {
    color: colors_1.tannerGray['600'],
    fontWeight: '500',
};
exports.UserPronounsTypography = (0, styled_1.default)(Typography_1.default)(__assign({}, PronounStyles));
exports.UserPronounsSpan = (0, styled_1.default)('span')(__assign({}, PronounStyles));
exports.InformationTypography = (0, styled_1.default)(Typography_1.default)({
    color: colors_1.tannerGray['600'],
});
//# sourceMappingURL=styles.js.map